import { render, staticRenderFns } from "./BigScreen.vue?vue&type=template&id=ad8cace4&scoped=true&"
import script from "./BigScreen.vue?vue&type=script&lang=js&"
export * from "./BigScreen.vue?vue&type=script&lang=js&"
import style0 from "./BigScreen.vue?vue&type=style&index=0&id=ad8cace4&lang=scss&scoped=true&"
import style1 from "./BigScreen.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8cace4",
  null
  
)

export default component.exports